// extracted by mini-css-extract-plugin
module.exports = {"allergenOption":"Allergen_allergenOption__329-H","select__option":"Allergen_select__option__3WtHy","icon":"Allergen_icon__2WMg2"};